export const CompassStar = ({ className = "w-8 h-8", star = "#C9A227", ring = "#C9A227", dot = "#14365C" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <circle cx="50" cy="50" r="44" fill="none" stroke={ring} strokeWidth="3" />
    <path d="M50 16 L54.5 45.5 L84 50 L54.5 54.5 L50 84 L45.5 54.5 L16 50 L45.5 45.5 Z" fill={star} />
    <circle cx="50" cy="50" r="3.5" fill={dot} />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3" data-testid="header-brand-logo">
    <img src="/logo-mark.png" alt="" className="w-11 h-11 shrink-0 rounded-full" />
    <span className="leading-none">
      <span className={`block font-sans text-[11px] sm:text-xs font-semibold tracking-[0.18em] ${dark ? "text-white" : "text-navy"}`}>
        FORESIGHT GLOBAL SYSTEMS
      </span>
    </span>
  </span>
);

export const LogoLockup = ({ className = "w-56" }) => (
  <img
    src="/logo.png"
    alt="Foresight Global Systems"
    className={className}
    data-testid="footer-brand-logo"
  />
);
